import * as React from 'react';
import { ICartItem } from '../../../interfaces/checkout/cart/cartType';
import { IOptionItem } from '../../../interfaces/checkout/cart/IOptionItem';
import { sum } from '../../../helpers/cart/sum';

export const hiDiscount = (item: ICartItem): React.ReactNode => {
    const optionItems: IOptionItem = item.options ? JSON.parse(item.options) : {};
    if (optionItems.hiDiscount) {
        return (
            <span key={`${item.item_id}_hiDiscount`}>
                {optionItems.hiDiscount?.label} {sum(optionItems.hiDiscount?.value || '0')} €<br />
            </span>
        );
    }
    return null;
};
